export default __webpack_public_path__ + "static/media/CEO3.40017b1a.jpg";